import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import { useLocation } from "react-router-dom"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "../data/LoginGlobal"

export default function ThirdTimeACharm({ isLightMode }) {
  const data = promotionsData.find(
    (promo) => promo.title === "Third Time's a Charm"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isDepositOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [isDepositOpen])

  const vipTiers = ["Emerald", "Sapphire", "Ruby", "Diamond", "Alexandrite"]

  // Dynamic table data, add more rows if needed
  const tableData = [
    {
      deposit: "First Deposit - no withdrawal",
      vipTiers: {
        Emerald: { minDeposit: 500, bonus: "✅" },
        Sapphire: { minDeposit: 1000, bonus: "✅" },
        Ruby: { minDeposit: 1500, bonus: "✅" },
        Diamond: { minDeposit: 2000, bonus: "✅" },
        Alexandrite: { minDeposit: 3000, bonus: "✅" },
      },
    },
    {
      deposit: "Second Deposit - no withdrawal",
      vipTiers: {
        Emerald: { minDeposit: 500, bonus: "✅" },
        Sapphire: { minDeposit: 1000, bonus: "✅" },
        Ruby: { minDeposit: 1500, bonus: "✅" },
        Diamond: { minDeposit: 2000, bonus: "✅" },
        Alexandrite: { minDeposit: 3000, bonus: "✅" },
      },
    },
    {
      deposit: "Third Deposit - qualified for the bonus",
      vipTiers: {
        Emerald: { minDeposit: 1000, bonus: "200" },
        Sapphire: { minDeposit: 2000, bonus: "400" },
        Ruby: { minDeposit: 3000, bonus: "600" },
        Diamond: { minDeposit: 4000, bonus: "800" },
        Alexandrite: { minDeposit: 6000, bonus: "1000" },
      },
    },
  ]

  const location = useLocation()
  const isAppPromo = location.pathname.startsWith("/app-promotion")

  useEffect(() => {
    const isAppPromotion = location.pathname.startsWith("/app-promotion")

    if (isAppPromotion) {
      const theme = isLightMode ? "light" : "dark"
      document.documentElement.dataset.theme = theme
      localStorage.setItem("theme", theme)
    }
  }, [location.pathname])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Third Time's a Charm</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Third Time's a Charm</h1>
                <h2>20% Daily Deposit Bonus</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>Daily Promotion</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Terms and Conditions: </strong>
                <p>
                  The first two consecutive deposits on our website in one day
                  (from 12:00PM to 11:59AM the next day) with no withdrawals
                  qualify the player for this promotion on his/her third
                  deposit, which receives a 20% Matching Deposit Bonus.
                </p>
                <br />
                <ol>
                  <li>
                    <p>
                      The player must deposit the exact amount based on their
                      VIP Level (please see the table for reference).
                    </p>
                  </li>
                  <li>
                    <p>
                      The player must first play and complete a 1x rollover of
                      their two consecutive deposits, with no following
                      withdrawals.
                    </p>
                  </li>
                  <li>
                    <p>
                      To receive the 20% Matching Deposit Bonus, the player must
                      deposit the required amount before the cut-off time of
                      11:59AM the following day.
                    </p>
                  </li>
                  <li>
                    <p>There's a maximum bonus a player can avail each day.</p>
                  </li>
                  <li>This promotion is FOR SLOTS GAMES ONLY.</li>
                  <li>
                    <p>
                      Table games, video poker, and fishing games from CQ9 and
                      JILI, as well as any other games we believe fall into this
                      category, are set to be excluded from the daily recharge
                      promotion.
                    </p>
                  </li>
                  <li>
                    <p>
                      Wagering Requirement: 5X Rollover Policy (the deposited
                      amount plus the bonus amount) before any cash out.
                    </p>
                  </li>
                  <li>
                    <p>
                      If the player loses the deposited amount, including the
                      bonus, please contact FGH support immediately to reset the
                      remaining rollover requirement.
                    </p>
                  </li>
                  <li>
                    <p>
                      We reserve the right to change, suspend or cancel the
                      promotion at any time.
                    </p>
                  </li>
                  <li>
                    Select <strong className="highlight">"APPLY BONUS"</strong>{" "}
                    in the Deposit or Cash In request to add the bonus to your
                    deposited amount.
                  </li>
                  <li>
                    Once applied, the bonus will be credited automatically
                    together with your deposited amount.
                  </li>
                </ol>
                <strong>Bonus Table:</strong>
                <div className="promotion-tnc-table-wrapper">
                  <table className="promotion-tnc-table">
                    <thead>
                      <tr>
                        <th rowSpan="2">No. Of Deposit</th>
                        {vipTiers.map((tier) => (
                          <th key={tier} colSpan="2">
                            {tier}
                          </th>
                        ))}
                      </tr>
                      <tr>
                        {vipTiers.map((tier) => (
                          <React.Fragment key={tier}>
                            <th>Min Deposit</th>
                            <th>Bonus</th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, data) => (
                        <tr key={data}>
                          <td>{row.deposit}</td>
                          {vipTiers.map((tier) => (
                            <React.Fragment key={tier}>
                              <td>{row.vipTiers[tier].minDeposit}</td>
                              <td>{row.vipTiers[tier].bonus}</td>
                            </React.Fragment>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {!isAppPromo && (
                  <>
                    <div className="promotion-tnc-cta">
                      {isLoggedIn ? (
                        <button
                          type="button"
                          className="promotion-cta-btn"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsDepositOpen(true)}
                        >
                          Make a deposit Now
                        </button>
                      ) : (
                        <LoginGlobal
                          label="Make a deposit Now"
                          btnClass="promotion-cta-btn"
                          onlyBtn={true}
                        />
                      )}
                    </div>
                    {isDepositOpen &&
                      createPortal(
                        <div className="modal-portal">
                          <Deposit
                            onClose={() => setIsDepositOpen(false)}
                            defaultBonusName="New Member Package Bonus"
                          />
                        </div>,
                        document.body
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
